import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import ReactHtmlParser from 'react-html-parser';
import InviteColleagues from '../../common/InviteColleagues';
import TagDisplay from '../../TagDisplay';
import { postRequest, deleteRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import userProfile from '../../../../assets/images/icons/user-profile-new.png';
import locationIcon from '../../../../assets/images/icons/location.png';
import './ConsultantSearchCard.scss';
var renderField = function renderField(attribute, icon, answer) {
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(attribute, " body-text-2 me-4")
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa ".concat(icon, " me-3")
  }), answer);
};
var renderStarRatings = function renderStarRatings(rating, note, recModal) {
  return /*#__PURE__*/React.createElement("div", {
    className: "rating-avg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-row--always lowered-margin"
  }, /*#__PURE__*/React.createElement(StarRatings, {
    rating: rating,
    starRatedColor: "#FED500",
    starHoverColor: "#FED500",
    starDimension: "20px",
    starSpacing: "2px",
    numberOfStars: 5,
    name: "rating_avg"
  }), /*#__PURE__*/React.createElement("span", {
    className: recModal ? 'num-ratings' : 'body-text-2 medium-weight'
  }, note)));
};
var renderRequestProposal = function renderRequestProposal(consultant, query, location, proposalRequested, projectResourceId) {
  var classes = "btn btn-".concat(location === 'search' ? 'secondary' : "primary action-button ".concat(proposalRequested ? 'disabled' : ''), " get-connected ").concat(location, "-get-connected");
  var proposalFromProject = location === 'search' ? '' : "&project_id=".concat(projectResourceId);
  return /*#__PURE__*/React.createElement("a", {
    href: "/users/".concat(consultant.resource_id, "/request_proposal?query_id=").concat(query).concat(proposalFromProject),
    target: "_blank",
    className: classes,
    onClick: function onClick() {
      analyticsTrack('Click Request Proposal on Profile Card', {
        location: location === 'search' ? 'Search Index' : location
      });
    },
    type: "button",
    rel: "noreferrer"
  }, "Request Proposal");
};
var renderBioSnippets = function renderBioSnippets(consultant, location) {
  return /*#__PURE__*/React.createElement("div", null, ReactHtmlParser("<div class=\"bio body-text-2 text-prewrap\">".concat(consultant.bio, "</div>")), location === 'search' && /*#__PURE__*/React.createElement("div", {
    className: "snippets mb-2"
  }, consultant.snippets.map(function (s) {
    return ReactHtmlParser("<p>...".concat(s, "...</p>"));
  })));
};
var ConsultantSearchCard = /*#__PURE__*/function (_Component) {
  function ConsultantSearchCard(props) {
    var _this;
    _classCallCheck(this, ConsultantSearchCard);
    _this = _callSuper(this, ConsultantSearchCard, [props]);
    var consultant = _this.props.consultant;
    _this.state = {
      favoriteId: consultant.user_favorite_id,
      colleagues: consultant.uninvited_colleagues || [],
      invitedColleagues: consultant.invited_colleagues || [],
      proposalRequested: props.proposalRequested || false
    };
    _this.toggleSave = _this.toggleSave.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.renderInviteColleagues = _this.renderInviteColleagues.bind(_this);
    _this.requestProposal = _this.requestProposal.bind(_this);
    _this.renderProfileHeader = _this.renderProfileHeader.bind(_this);
    return _this;
  }
  _inherits(ConsultantSearchCard, _Component);
  return _createClass(ConsultantSearchCard, [{
    key: "toggleSave",
    value: function toggleSave() {
      var _this2 = this;
      var _this$props = this.props,
        consultant = _this$props.consultant,
        csrfToken = _this$props.csrfToken;
      var favoriteId = this.state.favoriteId;
      if (favoriteId) {
        deleteRequest("/user_favorites/".concat(favoriteId), csrfToken).then(function () {
          _this2.setState({
            favoriteId: null
          });
        });
      } else {
        postRequest('/user_favorites', {
          user_favorite: {
            favorited_id: consultant.id,
            favorited_type: 'ConsultantProfile'
          }
        }, csrfToken).then(function (response) {
          _this2.setState({
            favoriteId: response.data
          });
          analyticsTrack('Click Save on the Profile Card', {
            location: 'Search Index'
          });
        });
      }
    }
  }, {
    key: "requestProposal",
    value: function requestProposal() {
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        consultant = _this$props2.consultant,
        projectResourceId = _this$props2.projectResourceId;
      var toastMessage = "You requested a proposal from ".concat(consultant.name, " Clora will be in touch shortly with next steps.");
      postRequest("/projects/".concat(projectResourceId, "/project_invitations"), {
        consultant_resource_id: consultant.resource_id,
        request_proposal: true
      }, csrfToken).then(function () {
        analyticsTrack('Clicked on Request Proposal', {
          location: 'Project Show',
          resource_id: consultant.resource_id
        });
      });
      toast.success(/*#__PURE__*/React.createElement("span", null, toastMessage));
      this.setState({
        proposalRequested: true
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(invited, newColleagues) {
      var invitedColleagues = this.state.invitedColleagues;
      this.setState({
        colleagues: newColleagues,
        invitedColleagues: invitedColleagues.concat(invited)
      });
    }
  }, {
    key: "renderInviteColleagues",
    value: function renderInviteColleagues() {
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        inviteUrl = _this$props3.inviteUrl,
        consultant = _this$props3.consultant,
        inviterEmailDomain = _this$props3.inviterEmailDomain,
        location = _this$props3.location;
      var _this$state = this.state,
        colleagues = _this$state.colleagues,
        invitedColleagues = _this$state.invitedColleagues;
      var buttonType = location !== 'search' ? 'btn-secondary' : 'btn-secondary-no-border';
      return /*#__PURE__*/React.createElement(InviteColleagues, {
        disabled: false,
        location: location,
        invitedColleagues: invitedColleagues,
        uninvitedColleagues: colleagues,
        csrfToken: csrfToken,
        resource: "Profile",
        resourceId: consultant.resource_id,
        inviteUrl: inviteUrl,
        handleFeedbacks: this.handleChange,
        styleType: "button",
        styleClass: "".concat(buttonType, " action-button"),
        cta: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-share-alt"
        }), /*#__PURE__*/React.createElement("span", {
          className: "ps-3"
        }, "Share")),
        header: "Share with colleagues",
        subtext: "Send this profile to other team members and make a decision about this candidate.",
        ownerMessagePlaceholder: "How does this candidate fit your needs?...",
        limitInvitesWithinCompany: true,
        inviterEmailDomain: inviterEmailDomain,
        preventCloseModalAfterSubmit: true,
        confirmationScreenAfterSend: true
      });
    }
  }, {
    key: "renderProfileHeader",
    value: function renderProfileHeader() {
      var consultant = this.props.consultant;
      return /*#__PURE__*/React.createElement("div", {
        className: "name-review-share-save"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar-image"
      }, /*#__PURE__*/React.createElement("img", {
        src: userProfile,
        className: "user-profile",
        alt: "User-Profile"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        id: "consultant-name",
        className: "consultant-name fs-hide"
      }, consultant.name_initials), renderStarRatings(consultant.rating_avg || 0, "(".concat(consultant.num_ratings, ")"), true), consultant.city_location && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
        src: locationIcon,
        className: "location-icon",
        alt: "Location-Marker"
      }), /*#__PURE__*/React.createElement("span", {
        className: "location-text"
      }, consultant.city_location)))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        consultant = _this$props4.consultant,
        location = _this$props4.location,
        query = _this$props4.query,
        viewingAsEmployer = _this$props4.viewingAsEmployer,
        projectSeniority = _this$props4.projectSeniority,
        projectNonPriorityTags = _this$props4.projectNonPriorityTags,
        projectPriorityTags = _this$props4.projectPriorityTags,
        projectResourceId = _this$props4.projectResourceId;
      var _this$state2 = this.state,
        favoriteId = _this$state2.favoriteId,
        proposalRequested = _this$state2.proposalRequested;
      return /*#__PURE__*/React.createElement("div", {
        id: "consultant-search-card",
        className: "consultant-search-card"
      }, location === 'Recommendations Modal' && /*#__PURE__*/React.createElement("a", {
        id: "consultant-profile",
        className: "consultant-profile",
        href: "/users/".concat(consultant.resource_id, "?project=").concat(projectResourceId),
        target: "_blank",
        onClick: function onClick() {
          analyticsTrack('Click View Profile on Profile Card', {
            location: location
          });
        },
        rel: "noreferrer"
      }, this.renderProfileHeader()), location === 'Project Show Consultant Recommendations' && /*#__PURE__*/React.createElement("a", {
        id: "consultant-profile",
        className: "consultant-profile",
        href: "/users/".concat(consultant.resource_id, "?project=").concat(projectResourceId),
        onClick: function onClick() {
          analyticsTrack('Click View Profile on Profile Card', {
            location: location
          });
        }
      }, this.renderProfileHeader()), /*#__PURE__*/React.createElement("div", {
        className: "consultant-search-card-non-profile"
      }, location === 'search' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "name-review-share-save-search mb-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-2 fs-hide"
      }, /*#__PURE__*/React.createElement("a", {
        className: "consultant-name",
        href: "users/".concat(consultant.resource_id),
        target: "_blank",
        rel: "noreferrer"
      }, consultant.name)), consultant.rating_avg && renderStarRatings(consultant.rating_avg, consultant.rating_avg.toFixed(1), false)), /*#__PURE__*/React.createElement("div", {
        className: "g-row--always"
      }, this.renderInviteColleagues(), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary-no-border",
        onClick: this.toggleSave,
        type: "button",
        disabled: !viewingAsEmployer
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(favoriteId ? 'fas' : 'far', " fa-heart")
      }), /*#__PURE__*/React.createElement("span", {
        className: "ps-3"
      }, "Save")))), /*#__PURE__*/React.createElement(TagDisplay, {
        consultant: consultant,
        areRoles: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "level-yrs-location"
      }, consultant.years_of_experience && renderField('years-of-experience', 'fa-id-card-alt', "".concat(consultant.years_of_experience, " year").concat(consultant.years_of_experience === 0 || consultant.years_of_experience > 1 ? 's' : '', " of experience")), consultant.seniority_levels && consultant.seniority_levels.length > 0 && renderField('seniority_levels', 'fa-certificate', consultant.seniority_levels.join(', ')), consultant.location && renderField('location', 'fa-map-marker-alt', consultant.location)), renderBioSnippets(consultant, location)), /*#__PURE__*/React.createElement(TagDisplay, {
        consultant: consultant,
        location: location,
        seniorityTags: projectSeniority,
        priorityTags: projectPriorityTags,
        nonPriorityTags: projectNonPriorityTags
      }), location === 'Recommendations Modal' && renderBioSnippets(consultant, location), location !== 'search' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TagDisplay, {
        consultant: consultant,
        areRoles: true
      }), /*#__PURE__*/React.createElement("div", {
        id: "card-actions",
        className: "consultant-search-card-actions container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "action-container",
        className: "button-action-container"
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        type: "button",
        className: "btn btn-primary action-button ".concat(proposalRequested && 'disabled', " get-connected"),
        onClick: this.requestProposal,
        tabIndex: 0
      }, "Request Proposal")), /*#__PURE__*/React.createElement("div", {
        className: "button-action-container"
      }, this.renderInviteColleagues()))), location === 'search' && /*#__PURE__*/React.createElement("div", {
        className: "consultant-search-card-actions"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/users/".concat(consultant.resource_id, "?query=").concat(query),
        target: "_blank",
        className: "btn btn-secondary-no-border view-profile ".concat(location, "-view-profile"),
        onClick: function onClick() {
          analyticsTrack('Click View Profile on Profile Card', {
            location: 'Search Index'
          });
        },
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-expand"
      }), "View Profile"), renderRequestProposal(consultant, query, location, proposalRequested, projectResourceId))), location !== 'search' && proposalRequested && /*#__PURE__*/React.createElement("div", {
        className: "proposal-requested"
      }, /*#__PURE__*/React.createElement("span", null, "Proposal Requested")));
    }
  }]);
}(Component);
ConsultantSearchCard.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  location: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  query: PropTypes.number,
  inviteUrl: PropTypes.string.isRequired,
  inviterEmailDomain: PropTypes.string,
  viewingAsEmployer: PropTypes.bool,
  projectSeniority: PropTypes.arrayOf(PropTypes.string),
  projectNonPriorityTags: PropTypes.arrayOf(PropTypes.string),
  projectPriorityTags: PropTypes.arrayOf(PropTypes.string),
  projectResourceId: PropTypes.string,
  proposalRequested: PropTypes.bool
};
ConsultantSearchCard.defaultProps = {
  query: null,
  inviterEmailDomain: '',
  viewingAsEmployer: true,
  projectSeniority: [],
  projectNonPriorityTags: [],
  projectPriorityTags: [],
  projectResourceId: '',
  proposalRequested: false
};
export default ConsultantSearchCard;